import { Dispatch } from '../../../common/state';

import { setTermValue } from '../advanced/term';

export function changeIsDemolishedInMoscowProgramm(value: boolean | undefined) {
  return (dispatch: Dispatch) => {
    dispatch(setTermValue('demolished_in_moscow_programm', value));
  };
}
